/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_ConnectionsInputs */



/**
* | output |
* | --- |
* | "Connections" |
*
* @param {Settings_Tab_ConnectionsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_tab_connections = /** @type {((inputs?: Settings_Tab_ConnectionsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_ConnectionsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppelingen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexions")
	return /** @type {LocalizedString} */ ("Connections")
});